// Alliance + party logos for a candidate, shared by the candidate bars and
// the latest-vote-updates list. Independent (BEBAS) candidates show only their
// dedicated logo; otherwise the editor-uploaded alliance logo takes precedence
// with the convention URL as fallback, followed by the party logo.
const CandidateIcons = ({ candidate }) => {
  const convention = candidate.alliance_en
    ? `https://sabah2025.orientaldaily.com.my/party/${candidate.alliance_en}.png`
    : '';
  const iconSrc = candidate.alliance_logo || convention;
  const partyIconSrc = candidate.party_logo || '';
  const isBebas = (candidate.party_eng || '').toUpperCase() === 'BEBAS';
  const bebasIconSrc = isBebas ? (candidate.bebas_logo || '') : '';

  if (bebasIconSrc) {
    return (
      <img
        src={bebasIconSrc}
        alt="bebas"
        style={{ width: '25px', height: '25px', verticalAlign: 'middle' }}
        onError={(e) => { e.target.style.display = 'none'; }}
      />
    );
  }
  if (!iconSrc && !partyIconSrc) return null;
  return (
    <>
      {iconSrc && (
        <img
          src={iconSrc}
          alt="icon"
          style={{ width: '25px', height: '25px', verticalAlign: 'middle' }}
          onError={(e) => {
            if (convention && e.target.src !== convention) e.target.src = convention;
          }}
        />
      )}
      {partyIconSrc && (
        <img
          src={partyIconSrc}
          alt="party"
          style={{ width: '25px', height: '25px', verticalAlign: 'middle', marginLeft: '4px' }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      )}
    </>
  );
};

export default CandidateIcons;
